export default {
  //   设置当前BarId, 每次增加1
  createBarId({ $storage: storage }) {
    let barId = storage.getLocalStorage('barId') || 0
    if (barId == null) {
      barId = 0
      storage.setLocalStorage('barId', barId)
    } else {
      barId++
      storage.setLocalStorage('barId', barId)
    }
    return barId
  },

  // 获取本地保存的对话数组
  getBarList({ $storage: storage }) {
    // 三天的缓存时间
    let barList = storage.getLocalStorage('barList') || []
    let array = barList.filter((item) => new Date().getTime() - item.time <= 1000 * 60 * 60 * 24 * 3)
    storage.setLocalStorage('barList', array)
    return storage.getLocalStorage('barList')
  },

  ressetBarList({ $storage: storage }) {
    storage.setLocalStorage('barId', 0)
    storage.setLocalStorage('barList', [])
  },

  // 获取指定id的对话
  getOneItem({ $storage: storage }, id) {
    let barList = storage.getLocalStorage('barList') || []
    let object = barList.find((item) => item.id === Number(id))
    return object
  },

  //新增一个新的对话
  addBar({ $storage: storage }, { id, type, question, search, params = {} }) {
    let barList = storage.getLocalStorage('barList') || []
    let askItem = {
      type,
      state: '',
      question, // 问题
      net_ref_list: [], // 网络引用
      opd_ref_list: [], // 现有的页面跳转
    }
    if (type === 'report') {
      askItem.params = params
      askItem.rpt_uuid = ''
      askItem.chapterList = []
    } else {
      askItem.params = { search, question }
    }
    let obj = { id, name: question.slice(0, 14), time: new Date().getTime(), dataList: [askItem], isNew: true }
    barList.unshift(obj)
    storage.setLocalStorage('barList', JSON.stringify(barList))
    return barList
  },

  // 删除一个对话
  deleteBar({ $storage: storage }, { id }) {
    let barList = storage.getLocalStorage('barList') || []
    barList = barList.filter((item) => item.id !== id)
    storage.setLocalStorage('barList', JSON.stringify(barList))
    return barList
  },

  // 已有的对话中，新增一个新的问题
  addQuestion({ $storage: storage }, { id, type, question, search }) {
    let barList = storage.getLocalStorage('barList') || []
    barList.forEach((item) => {
      if (item.id === Number(id)) {
        let askItem = {
          type,
          state: '',
          question, // 问题
          params: { search, question },
          net_ref_list: [], // 网络引用
          opd_ref_list: [], // 现有的页面跳转
        }
        item.dataList.push(askItem)
      }
    })
    storage.setLocalStorage('barList', JSON.stringify(barList))
  },

  // 删除对话中的问题
  deleteQuestion({ $storage: storage }, { id }) {
    let barList = storage.getLocalStorage('barList') || []
    barList.forEach((item) => {
      if (item.id === Number(id)) {
        item.dataList.pop()
      }
    })
    storage.setLocalStorage('barList', JSON.stringify(barList))
  },

  // 更新对话中的内容
  updateBar({ $storage: storage }, { id, content, type, state, rpt_uuid, chapterList, reasoning_content, net_ref_list, opd_ref_list }) {
    let barList = storage.getLocalStorage('barList') || []
    barList.forEach((item) => {
      if (item.id === Number(id)) {
        item.isNew = false
        item.dataList[item.dataList.length - 1].type = type
        item.dataList[item.dataList.length - 1].state = state
        item.dataList[item.dataList.length - 1].net_ref_list = net_ref_list
        item.dataList[item.dataList.length - 1].opd_ref_list = opd_ref_list
        if (type === 'report') {
          item.dataList[item.dataList.length - 1].rpt_uuid = rpt_uuid
          item.dataList[item.dataList.length - 1].chapterList = chapterList
        } else {
          item.dataList[item.dataList.length - 1].content = content
          item.dataList[item.dataList.length - 1].reasoning_content = reasoning_content
        }
      }
    })
    storage.setLocalStorage('barList', JSON.stringify(barList))
  },
}
